import { render, staticRenderFns } from "./AppRegister.vue?vue&type=template&id=2a36224d&"
import script from "./app-register.ts?vue&type=script&lang=ts&"
export * from "./app-register.ts?vue&type=script&lang=ts&"
import style0 from "./AppRegister.vue?vue&type=style&index=0&id=2a36224d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports